module.exports = __webpack_public_path__ + "img/tanzhiwenlogo.665655c6.png";